// used by legacy patient file page
export const UPDATE_SELECTED_TAB = 'PatientFile.UPDATE_SELECTED_TAB';

export const UPDATE_PATIENT_TRIGGER = 'patient/PATIENT_PUT_TRIGGER';



// WEBPACK FOOTER //
// ./src/state/reducers/patient/types.js